


















import { Component, Prop, Vue, Watch } from 'vue-property-decorator';
import { UserProfile } from '@/models/user-profile'

@Component({ components: {} })
export default class UserAvatar extends Vue {
  @Prop(String) public src!: string;

  get image() {
    if (this.src) {
      return this.src;
    } else {
      return 'https://storage.googleapis.com/mixlet.appspot.com/default-user-icons/1.png';
    }
  }
}
